/**
 * SpaceMemberMentionChip
 *
 * Renders a structured Space-member mention inside chat messages.
 *
 * Primary responsibilities:
 * - Show shared Space member mentions as compact inline chips
 * - Keep mention labels readable without another fetch
 *
 * Dependencies:
 * - Tabler icons
 * - Shared class name helper
 */

"use client"

import { IconAt } from "@tabler/icons-react"
import { cn } from "@/lib/utils"

type SpaceMemberMentionChipProps = {
  label: string
  userId?: string
  className?: string
}

export function SpaceMemberMentionChip({
  label,
  userId,
  className
}: SpaceMemberMentionChipProps) {
  return (
    <span
      className={cn(
        "border-foreground/10 bg-muted/70 text-foreground inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 align-middle text-xs font-medium no-underline",
        className
      )}
      title={userId ? `${label} (${userId})` : label}
    >
      <IconAt className="size-3 shrink-0" />
      <span className="max-w-[160px] truncate">{label}</span>
    </span>
  )
}
